import {
	connect
} from 'react-redux'
import LabelEditComponent from '../components/LabelEditComponent.jsx';
import {
	findLabelById,
	changeLabelValue,
	editOrderLabel,
	cleanOrderLabelAlert,
	cleanOrderLabelInput
} from '../actions';

const mapStateToProps = (state) => ({
	roles: state.getIn(['authReducer', 'roles']),
	labelFormBean: state.getIn(['labelReducer', 'labelFormBean']),
	labelFormBeanValidation: state.getIn(['labelReducer', 'labelFormBeanValidation']),
	alertStyle: state.getIn(['labelReducer', 'alertStyle']),
	alertMessage: state.getIn(['labelReducer', 'alertMessage']),
	alertSearchStyle: state.getIn(['labelReducer', 'alertSearchStyle']),
	alertSearchMessage: state.getIn(['labelReducer', 'alertSearchMessage'])
})

const mapDispatchToProps = (dispatch) => ({
	searchLabelId: (searchLabelIdInput) => {
		dispatch(findLabelById({ labelId: searchLabelIdInput }));
	},
	editOrderLabel: (labelBean) => {
		dispatch(editOrderLabel(labelBean));
	},
	setValue: (id, value) => {
		dispatch(changeLabelValue({
			id: id,
			value: value
		}))
	},
	cleanAlert: () => {
		dispatch(cleanOrderLabelAlert());
	},
	cleanInput: () => {
		dispatch(cleanOrderLabelInput());
	}
})

const LabelEditContainer = connect(
	mapStateToProps,
	mapDispatchToProps
)(LabelEditComponent)

export default LabelEditContainer;


// WEBPACK FOOTER //
// ./src/containers/LabelEditContainer.jsx